import { Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'

export const CopyableError = ({ error }: { error: Error | string }) => {
  const [copied, setCopied] = useState(false)

  const errorMessage = error instanceof Error ? error.message : String(error)
  const errorStack = error instanceof Error ? error.stack : ''

  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.setAttribute('readonly', '')
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      return document.execCommand('copy')
    } finally {
      document.body.removeChild(textArea)
    }
  }

  const handleCopy = async () => {
    const text = `${errorMessage}\n\n${errorStack}`

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else if (!fallbackCopyTextToClipboard(text)) {
        setCopied(false)
        return
      }
    } catch {
      if (!fallbackCopyTextToClipboard(text)) {
        setCopied(false)
        return
      }
    }

    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="subtitle2" fontWeight="bold">
            Error Details
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={6}
            value={`${errorMessage}${errorStack ? `\n\n${errorStack}` : ''}`}
            InputProps={{ readOnly: true }}
            size="small"
          />
          <Box>
            <Button variant="outlined" size="small" onClick={handleCopy}>
              {copied ? 'Copied!' : 'Copy Error'}
            </Button>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  )
}
